interface Tab<T extends string> {
  id: T
  label: string
  meta?: string
}

interface Props<T extends string> {
  tabs: Tab<T>[]
  active: T
  onChange: (id: T) => void
}

export default function Tabs<T extends string>({ tabs, active, onChange }: Props<T>) {
  return (
    <div
      role="tablist"
      className="cp-tabs"
      style={{
        display: 'flex',
        gap: 28,
        borderBottom: '0.5px solid rgba(244,242,242,0.1)',
        marginBottom: 28,
        // Labels must stay on one line so the active underline tracks the
        // whole tab; the bar scrolls sideways when they don't all fit.
        overflowX: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      {tabs.map((t) => {
        const isActive = t.id === active
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(t.id)}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '12px 0 14px',
              cursor: 'pointer',
              position: 'relative',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              fontFamily: "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
              fontWeight: isActive ? 700 : 500,
              fontSize: 12,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: isActive ? '#F4F2F2' : 'rgba(198,196,185,0.55)',
              transition: 'color 160ms ease',
            }}
          >
            {t.label}
            {t.meta && (
              <span
                style={{
                  marginLeft: 8,
                  fontFamily: "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
                  fontSize: 10,
                  fontWeight: 500,
                  color: isActive ? '#C2E530' : 'rgba(198,196,185,0.35)',
                  letterSpacing: 0,
                }}
              >
                {t.meta}
              </span>
            )}
            {isActive && (
              <span
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: -1,
                  height: 2,
                  background: '#C2E530',
                }}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}
